/* Winter Essentials, Moon Bundles bridge (v2.1 draft, Oct 26 2026). Loaded ONLY when Theme settings > Deals > "Use Moon Bundles" is ON.
   It never adds or enables Moon. It watches the theme-owned wrapper [data-we-moon-box] (Moon's app block lives inside it) and tells the Duo and
   Ice grips scripts what the shopper picked in Moon, so the theme's own labels, sticky bar and Add to cart read the Moon choice.
   States (classes on the page root, styled in we-moon.css):
     pending  Moon has not drawn its offers yet          -> theme pickers and deal rows stay hidden (no flash of a second picker)
     live     Moon drew its offers                       -> Moon's picker is the only picker
     failed   no Moon offers after 6 s (script blocked, plan limit, bundle not Active, flag ON too early)
              -> fallback "single": pickers and every deal text hidden, base prices only (safe when the native deals are OFF)
              -> fallback "theme":  the v2.0 theme pickers and deal text come back (only while the native deals are still ON)
     ended    the end moment passed (DEAL-END-DATE, from the one date setting via data-we-until / data.ends) -> wrapper hidden, Moon bypassed
   Moon facts used (read from Moon's public script, verified against v4.0.3 on Oct 27): window.MoonBundle[id].config is a Svelte store whose value has
   offers[offerId].isSelected and, per offer, one array of variant objects per product; a hidden input [data-moonbundle-quantity] carries the units. */
(function () {
  if (window.WEMoon) return;
  var TIMEOUT_MS = 6000;
  var POLL_MS = 400;
  var MSG = 'Please complete all product choices before adding to cart';   // the same words as Moon's own message (Moon admin); no price, no urgency, no claim
  var SKIP = { gifts: 1, upsells: 1, isSelected: 1, quantityToAdd: 1, lastModifiedVariantId: 1, sellingPlan: 1 };

  function vid(x) { return String(x == null ? '' : (x.id != null ? x.id : x)).split('/').pop(); }

  function readConfig() {
    var m = window.MoonBundle;
    if (!m || typeof m !== 'object') return null;
    var keys = Object.keys(m);
    for (var i = 0; i < keys.length; i++) {
      var inst = m[keys[i]];
      var store = inst && inst.config;
      if (store && typeof store.subscribe === 'function') {
        var value = null;
        try { var off = store.subscribe(function (v) { value = v; }); if (typeof off === 'function') off(); } catch (e) { value = null; }
        if (value && value.offers) return value;
      }
    }
    return null;
  }

  function connect(root, opts) {
    opts = opts || {};
    var box = root.querySelector('[data-we-moon-box]');
    // Duo page: Moon's block is printed by sections/we-moon-slot.liquid; move it into the theme-owned wrapper (the wrapper carries the end guard).
    var src = document.querySelector('[data-we-moon-src]');
    if (box && src && !box.contains(src)) { while (src.firstChild) box.appendChild(src.firstChild); }
    var fallback = root.getAttribute('data-we-moon-fallback') === 'theme' ? 'theme' : 'single';
    var endMs = Date.parse(opts.ends || '') || 0;
    var mainIds = (opts.mainIds || []).map(String);
    var otherIds = (opts.otherIds || []).map(String);
    var started = Date.now();
    var failMs = opts.timeout > 0 ? opts.timeout : TIMEOUT_MS;   // v2.2 fix F1: the home Winter deals call passes 2500 so a blocked Moon collapses fast; the Duo page keeps 6000
    var state = 'pending';
    var last = '';
    var timer = null;

    function ended() { return endMs > 0 && Date.now() >= endMs; }

    // v2.2 Best deals front (Oct 27 2026): the home page "Winter deals" cards link to the Duo page as ?moon_offer=<Moon offer id>. Once Moon has drawn, click THAT offer
    // once, as the shopper would (Moon's own click handler selects it and prices it; nothing is added, nothing is sent). Only a 36-character id, only once per page,
    // only on a page that has the offer. Anything else in the URL is ignored. A later choice by the shopper is never overridden.
    var preDone = false;
    function preselect() {
      if (preDone || !box) return;
      var want = '';
      try { want = new URLSearchParams(window.location.search).get('moon_offer') || ''; } catch (e) { want = ''; }
      if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(want)) { preDone = true; return; }
      var wrap = box.querySelector('.moonbundle-option-wrapper[data-offer-id="' + want + '"]');
      if (!wrap) return;
      var opt = wrap.querySelector('.moonbundle-option');
      if (opt && !/moonbundle-option-active/.test(opt.className)) opt.click();
      // Sentry AUDIT-2 F2: bring a below-the-fold preselected offer into view once (a retry covers a smooth scroll cancelled by the gallery); an offer already in the upper part of the screen is left alone.
      var low = function () { var q = wrap.getBoundingClientRect(); return q.top >= window.innerHeight * 0.75 || q.bottom < 0; };
      try { if (low()) { wrap.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); window.setTimeout(function () { try { if (low()) wrap.scrollIntoView({ block: 'center', behavior: 'auto' }); } catch (e2) { /* ignore */ } }, 1600); } } catch (e) { /* ignore */ }
      preDone = true;
    }

    function drawn() {
      return Boolean(box && box.querySelector('.moonbundle-option-wrapper, .moonbundle-option, [class*="moonbundle-option-"]'));
    }

    function selection() {
      var cfg = readConfig();
      if (!cfg) return { known: false, main: 0, other: 0 };
      var ids = Object.keys(cfg.offers);
      var sel = null;
      for (var i = 0; i < ids.length; i++) if (cfg.offers[ids[i]] && cfg.offers[ids[i]].isSelected === true) { sel = cfg.offers[ids[i]]; break; }
      if (!sel) return { known: false, main: 0, other: 0 };
      var main = 0, other = 0, unknown = 0;
      Object.keys(sel).forEach(function (k) {
        if (SKIP[k] || !Array.isArray(sel[k])) return;
        sel[k].forEach(function (v) {
          if (v && v.available === false) return;
          var id = vid(v);
          if (mainIds.indexOf(id) > -1) main++;
          else if (otherIds.indexOf(id) > -1) other++;
          else unknown++;
        });
      });
      if (unknown > 0 || main + other === 0) return { known: false, main: main, other: other };
      return { known: true, main: main, other: other };
    }

    function colours() {
      // Moon's own per-unit colour selectors, if the offer has them switched on (Moon: "Show product variants selection").
      var has = Boolean(box && box.querySelector('[class*="moonbundle-options-variant"], [class*="moonbundle-multi-product-variants"], [class*="moonbundle-variant"]'));
      root.classList.toggle('we-moon-has-variants', has);
    }

    // Text sweep (Sentry RULINGS-1 R2). Moon's default strings must never show: timer, "cart expires", "Most popular" / "Best seller" / "Best value" /
    // "Popular", "Save" / "You save" / "% off" / "OFF", "free", "Limited" / "Only N left" / "Selling fast" / "Sold out", gift, upsell, "frequently bought",
    // "Hurry". CSS hides Moon's known classes (we-moon.css 4b); this sweep hides any other small element whose own text says one of them, and marks every
    // struck-through element (data-we-strike) so the CSS can label it "Price without the deal" or hide it (setting moon_show_compare_at).
    var BANNED = /(^|[^a-z])(save|saves|saving|savings|you save|off|free|popular|best seller|bestseller|best value|best|limited|hurry|selling fast|sold out|expires?|expired|countdown|gift|upsell|frequently bought)([^a-z]|$)|%|only\s+\d+\s+left|\d+\s+left/i;
    var KNOWN_STRIKE = '.moonbundle-option-old-price, .moonbundle-multi-product-price-old-price, .moonbundle-price-crossed';
    function ownText(el) { var t = ''; for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) t += n.nodeValue; return t.replace(/\s+/g, ' ').trim(); }
    function cents(t) { var m = String(t).replace(/,/g, '').match(/\d+(\.\d+)?/); return m ? Math.round(parseFloat(m[0]) * 100) : -1; }
    function sweep() {
      if (!box) return;
      var all = box.querySelectorAll('*');
      var banned = 0, struck = 0;
      for (var i = 0; i < all.length; i++) {
        var el = all[i], tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'OPTION' || tag === 'SELECT' || tag === 'INPUT' || tag === 'SVG' || tag === 'PATH') continue;
        if (el.closest('.moonbundle-variant-error-message, select, .we-moon__h')) continue;
        // strikes: every struck-through element gets data-we-strike = "multi" (its offer holds a multi-product price: the only place a Moon strike may show,
        // owner words via Goji 11:58 PM CT, B4/B5/B6) or "single" (never shown). CSS does the rest (we-moon.css 4).
        var deco = '';
        try { deco = window.getComputedStyle(el).textDecorationLine || ''; } catch (e) { deco = ''; }
        if (tag === 'S' || tag === 'DEL' || tag === 'STRIKE' || deco.indexOf('line-through') > -1 || el.matches(KNOWN_STRIKE)) {
          if (!el.closest('[data-we-strike]') || el.hasAttribute('data-we-strike')) {
            var offer = el.closest('.moonbundle-option-wrapper') || el.closest('.moonbundle-offer-wrapper > *') || el.parentElement;
            var multi = el.matches('.moonbundle-multi-product-price-old-price') || Boolean(offer && (offer.querySelector('[class*="moonbundle-multi-product"]') || offer.matches('[class*="moonbundle-multi-product"]')));
            var kind = multi ? 'multi' : 'single';
            // Round 4 (grips, Goji/owner via Wren 2:11 AM CT): the 1-pair row's strike shows when it is exactly the page's base price ($24.99 = data-price);
            // any other single-product strike (the 2-pair row's $49.98) stays hidden. CSS prints the same "Price without the deal" label, no Save line.
            if (!multi && box.getAttribute('data-we-moon-box') === 'grips' && cents(el.textContent) === Number(root.getAttribute('data-price'))) kind = 'base';
            el.setAttribute('data-we-strike', kind);
          }
          struck++;
          continue;
        }
        if (el.hasAttribute('data-we-banned')) { banned++; continue; }
        var txt = ownText(el);
        if (!txt) continue;
        var leaf = el.children.length === 0;
        if (BANNED.test(txt) && (leaf || (txt.length < 60 && !el.querySelector('button, input, select, [class*="moonbundle-option-wrapper"]')))) {
          el.setAttribute('data-we-banned', '1');
          banned++;
        }
      }
      box.setAttribute('data-we-swept', banned + ':' + struck);
    }

    function paint() {
      ['pending', 'live', 'failed', 'ended'].forEach(function (s) { root.classList.toggle('we-moon-' + s, s === state); });
      root.classList.toggle('we-moon-theme', (state === 'failed' && fallback === 'theme'));
      if (box) box.hidden = state === 'ended';
      // Round 4 (Sentry AUDIT-3 item 3): at the end frame also hide every theme block that carries its own end date (the deal rows and strikes), in the SAME
      // frame, so they cannot show for one frame before the page's own end script hides them (same [hidden] mechanism: [data-we-until][hidden] is display:none).
      if (state === 'ended') {
        var dated = document.querySelectorAll('[data-we-until]');
        for (var di = 0; di < dated.length; di++) { var t = Date.parse(dated[di].getAttribute('data-we-until')); if (t > 0 && Date.now() >= t) dated[di].hidden = true; }
      }
      // Round 5 (Sentry AUDIT-4 fix 1): Moon's script hides and disables the grips quantity input (and the minus button) while its rows are up; the ended
      // state gives the theme stepper back, so undo what Moon set (inline display, disabled, hidden). The page's own update() re-applies the right
      // disabled state of the minus/plus buttons right after (onChange fires on this state change).
      if (state === 'ended') {
        var gq = document.querySelectorAll('[data-grp-qty], [data-grp-step]');
        for (var gi = 0; gi < gq.length; gi++) { gq[gi].style.removeProperty('display'); gq[gi].removeAttribute('hidden'); gq[gi].disabled = false; }
        // Moon draws late and re-applies this on its own events (updateQuantityInForm), so watch the input itself once the end is reached and put it back.
        if (window.MutationObserver) {
          var qin = document.querySelectorAll('[data-grp-qty]');
          for (var qi = 0; qi < qin.length; qi++) {
            if (qin[qi].getAttribute('data-we-qty-watch')) continue;
            qin[qi].setAttribute('data-we-qty-watch', '1');
            (function (inp) {
              new MutationObserver(function () {
                if (state !== 'ended') return;
                if (inp.style.display) inp.style.removeProperty('display');
                if (inp.disabled) inp.disabled = false;
              }).observe(inp, { attributes: true, attributeFilter: ['style', 'disabled'] });
            })(qin[qi]);
          }
        }
      }
      // B-2: at the end moment hide EVERY Moon widget on the page (the block lives inside our box, but the embed can draw its own copy elsewhere).
      // Hiding is not a stop: Moon's discount function and cart rewrite keep running until the owner pauses the bundles in Moon (Dec 10, 11:59 PM CT).
      var comps = document.querySelectorAll('moonbundle-component');
      for (var ci = 0; ci < comps.length; ci++) {
        if (state === 'ended') { comps[ci].setAttribute('data-we-hid', '1'); comps[ci].hidden = true; comps[ci].style.setProperty('display', 'none', 'important'); }
        else if (comps[ci].hasAttribute('data-we-hid')) { comps[ci].removeAttribute('data-we-hid'); comps[ci].hidden = false; comps[ci].style.removeProperty('display'); }
      }
    }

    function tick() {
      var prev = state;
      if (ended()) state = 'ended';
      else if (drawn()) state = 'live';
      else if (state !== 'live' && Date.now() - started > failMs) state = 'failed';
      else if (state === 'live') state = 'pending';   // Moon removed its offers (bundle paused or deactivated) after drawing them
      if (state === 'live') { colours(); sweep(); preselect(); }
      var s = state === 'live' ? selection() : { known: false, main: 0, other: 0 };
      var sig = state + '|' + s.known + '|' + s.main + '|' + s.other;
      if (prev !== state) paint();
      if (sig !== last) { last = sig; if (typeof opts.onChange === 'function') opts.onChange(state, s); }
      if (state === 'ended') { window.clearInterval(timer); window.clearTimeout(endTimer); }
      else armEnd();
    }

    // Sentry AUDIT-2 F3: the end moment fires on its own timer (exact, not up to POLL_MS late). The 400 ms poll stays for Moon drawing/removing its offers.
    // setTimeout cannot take more than 2^31-1 ms, so a far end re-arms in steps; a sleeping tab or a clock jump is caught by visibilitychange / pageshow / focus.
    var endTimer = null;
    function armEnd() {
      if (!(endMs > 0)) return;
      window.clearTimeout(endTimer);
      endTimer = window.setTimeout(tick, Math.max(0, Math.min(endMs - Date.now(), 2147483647)));
    }
    function wake() { if (state !== 'ended') tick(); }
    document.addEventListener('visibilitychange', wake);
    window.addEventListener('pageshow', wake);
    window.addEventListener('focus', wake);

    paint();
    timer = window.setInterval(tick, POLL_MS);
    window.setTimeout(tick, 0);
    // Moon's offers can require a pick for every product ("Please complete all product choices before adding to cart", set in Moon, shown by Moon
    // in .moonbundle-variant-error-message). incomplete() = Moon itself marks a selector invalid. explain() makes sure the shopper sees ONE such
    // message: Moon's own if it is showing, otherwise the same words in the theme status line, and brings the Moon block into view.
    function incomplete() { return Boolean(box && box.querySelector('.moonbundle-variant-select-invalid')); }
    function explain(statusEl) {
      if (!box) return;
      box.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      window.setTimeout(function () {
        var m = box.querySelector('.moonbundle-variant-error-message');
        var moonShows = Boolean(m && m.offsetParent !== null && m.textContent.trim());
        if (statusEl && incomplete()) statusEl.textContent = moonShows ? '' : MSG;
      }, 250);
    }
    // diagnose(): console helper for the add-to-cart question. WEMoon.diagnose() on a product page shows whether Moon wrapped fetch, which component
    // and offer it holds, and the last body Moon sent. Read only.
    function diagnose() {
      var c = document.querySelector('moonbundle-component');
      var sm = c && c.storeFrontManager;
      return { fetchWrappedByMoon: Boolean(window.fetch && window.fetch._moonbundle), components: document.querySelectorAll('moonbundle-component').length,
        instanceId: c ? c.id : null, selectedOfferId: sm ? sm.selectedOfferId : null, state: state, selection: state === 'live' ? selection() : null };
    }
    return { diagnose: diagnose, state: function () { return state; }, selection: selection, ended: ended, tick: tick, box: box, incomplete: incomplete, explain: explain, sweep: sweep };
  }

  window.WEMoon = { connect: connect };
})();
